module.exports = __webpack_public_path__ + "img/annualForecastOrange.ac248f7b.png";